import React from "react";
import { Text, Button, makeStyles, tokens } from "@fluentui/react-components";
import { DocumentMultiple24Regular } from "@fluentui/react-icons";
import { useTypographyStyles } from "../../../styles/typography.styles";

interface EmptyStateProps {
  hasFilters: boolean;
  onClearFilters?: () => void;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXXL,
    textAlign: "center",
    gap: tokens.spacingVerticalL,
  },
  icon: {
    fontSize: "64px",
    color: tokens.colorNeutralForeground3,
  },
  message: {
    color: tokens.colorNeutralForeground2,
    maxWidth: "400px",
  },
});

export const EmptyState: React.FC<EmptyStateProps> = ({
  hasFilters,
  onClearFilters,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div className={styles.container}>
      <DocumentMultiple24Regular className={styles.icon} />

      <Text className={typography.emptyStateTitle}>
        {hasFilters ? "No items match your filters" : "No status items yet"}
      </Text>

      <Text className={styles.message}>
        {hasFilters
          ? "Try adjusting your filters to see more items"
          : "Status items will appear here once they are created for this workbook"}
      </Text>

      {hasFilters && onClearFilters && (
        <Button appearance="primary" onClick={onClearFilters}>
          Clear Filters
        </Button>
      )}
    </div>
  );
};
